import React from "react";
import { Star } from "lucide-react";

/**
 * Editorial-style testimonials block — asymmetric vertical layout with
 * generous whitespace, inspired by the client's reference screenshot.
 */
const TESTIMONIALS = [
  {
    quote: "It paid for itself in the first month. Now it's just incremental revenue we weren't capturing before.",
    attribution: "KURT NIELSON · AURELIA HOTEL GROUP",
    align: "left",
    offset: "md:ml-0 md:mr-auto md:pl-4 lg:pl-24",
  },
  {
    quote: "It's attractive and easy. Guests see it from across the room and it pulls them in every single time.",
    attribution: "CREOLE CUISINE · NEW ORLEANS",
    align: "right",
    offset: "md:mr-0 md:ml-auto md:pr-4 lg:pr-24",
  },
  {
    quote: "It blows traditional photo booths out of the water. The AI actually understands who our guests are.",
    attribution: "JUST CALL MALIK · EXPERIENTIAL AGENCY",
    align: "left",
    offset: "md:ml-0 md:mr-auto md:pl-4 lg:pl-48",
  },
];

export default function HeroTestimonials() {
  return (
    <section
      data-testid="hero-testimonials"
      className="relative bg-stori-bg border-b border-stori-border overflow-hidden"
    >
      {/* Subtle ambient backdrop */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/4 -left-40 w-[500px] h-[500px] bg-stori-cyan/4 rounded-full blur-[140px]" />
        <div className="absolute bottom-1/4 -right-40 w-[500px] h-[500px] bg-stori-cyan/3 rounded-full blur-[140px]" />
      </div>

      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10 py-28 lg:py-40">
        <div className="space-y-28 lg:space-y-40">
          {TESTIMONIALS.map((t, i) => (
            <figure
              key={i}
              data-testid={`hero-testimonial-${i}`}
              className={`max-w-2xl ${t.offset} ${t.align === "right" ? "text-right" : "text-left"}`}
            >
              <div
                className={`flex items-center gap-1 mb-6 ${
                  t.align === "right" ? "justify-end" : "justify-start"
                }`}
                aria-label="5 out of 5 stars"
              >
                {Array.from({ length: 5 }).map((_, s) => (
                  <Star key={s} className="w-3.5 h-3.5 text-stori-cyan fill-stori-cyan" />
                ))}
              </div>
              <blockquote className="font-heading text-3xl sm:text-4xl lg:text-5xl text-white font-medium leading-[1.2] tracking-tight">
                &ldquo;{t.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-8 font-mono text-[11px] uppercase tracking-[0.22em] text-stori-muted">
                {t.attribution}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
